import { Component, Input, OnChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../common/global-variables';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { VcaAlertsService } from '../../../../../../common/vca-alerts/vca-alerts.service';
import { DataProtectionVariables } from '../../../dataprotection-common/dataprotection-variables';
import { storageRender, policyRender } from '../../../dataprotection-common/common-renderers';

import { ResourcePoolService } from './resource-pool-details-vc.service';
import { JobsNotifierService } from '../../../../../services/job-notifier.service';
import { JobConstants } from '../../../../../../common/utils/job-constants';
import { Subscription } from 'rxjs/Rx';
import { RefreshSharedService } from '../../../../../refresh-shared-service';

@Component({
    selector: 'dps-resource-pool-details-vc',
    providers: [ResourcePoolService],
    styles: [require('./resource-pool-details-vc.scss')],
    template: require('./resource-pool-details-vc.html')
})
export class ResourcePoolDetails {

    @Input() entity: any;

    private resourcePool: any;
    private policyData: any = {};
    private loaded: boolean;
    private isPolicySet: boolean;

    private resourcePoolName: string;
    private vcHost: string;

	private deletedVms: any;
    private deletedVmCount: any;
    private policy: any;
    private storageConsumed: any;

    private isModalClosable: boolean = true;

    private isAddPolicyModalVisible: boolean;
    private applyPolicyModalHeader: String;
    private applyPolicyModalMode: String;

    private isDeletePolicyModalVisible: boolean;
    private deletePolicyModalHeader: String;
    private deletePolicyModalMode: String;

    private isConfigureEmailModalVisible: boolean;

    private isRestorePointsModalVisible: boolean;
    private restorePointModalHeader: String;
    private restorePointsModalMode: String;
    private selectedDeletedVm: any = {};
    private rsService: RefreshSharedService;
    private refreshSubscription: Subscription;
    private currentClassName: string = '';
    private currentChanges: any;
    private getRPCompleted: boolean = false;
    private getDelVMCompleted: boolean = false;

    constructor(private translate:TranslateService,
                private activatedRoute: ActivatedRoute,
                private resourcePoolService: ResourcePoolService,
                private alert: VcaAlertsService,
                private jobNotifierService: JobsNotifierService,
                private rss: RefreshSharedService) {
        translate.use(GlobalVariables.LOCALE);
        this.isPolicySet = false;
        this.isAddPolicyModalVisible = false;
        this.isDeletePolicyModalVisible = false;
        this.isRestorePointsModalVisible = false;
        this.rsService = rss;
        this.currentClassName = 'ResourcePoolDetails';
    }

    onAddPolicyClick = (event) => {
        this.applyPolicyModalHeader = this.translate.instant('vcDpsModule.applyPolicy.popupHeaderApplyPolicyResourcePool') + this.entity.name;
        this.applyPolicyModalMode = DataProtectionVariables.POLICY_POPUP_MODES['ADD_RESOURCE_POOL_POLICY'];
        this.isAddPolicyModalVisible = true;
    };

    onEditPolicyClick = (event) => {
        this.applyPolicyModalHeader = this.translate.instant('vcDpsModule.applyPolicy.popupHeaderEditPolicyResourcePool') + this.entity.name;
        this.applyPolicyModalMode = DataProtectionVariables.POLICY_POPUP_MODES['UPDATE_RESOURCE_POOL_POLICY'];
        this.isAddPolicyModalVisible = true;
    };

    onAddPolicyClose = (emittedData) => {
        if (!emittedData) {
            this.isAddPolicyModalVisible = false;
            this.isModalClosable = true;
        } else if (emittedData.status === 'pending') {
            this.isModalClosable = false;
        } else if (emittedData.status === 'success') {
            this.isAddPolicyModalVisible = false;
            this.isModalClosable = true;
            this.getResourcePoolDetails(this.entity.entity_id, this.entity.vcenter_instanceId);
        } else {
            this.isModalClosable = true;
        }
    };

    onDeletePolicyClick = (event) => {
        this.deletePolicyModalHeader = this.translate.instant('vcDpsModule.deletePolicy.rp.popupHeader');
        this.deletePolicyModalMode = DataProtectionVariables.POLICY_POPUP_MODES['DELETE_RESOURCE_POOL_POLICY'];
        this.isDeletePolicyModalVisible = true;
    };

    onDeletePolicyClose = (emittedData) => {
        if (!emittedData) {
            this.isDeletePolicyModalVisible = false;
            this.isModalClosable = true;
        } else if (emittedData.status === 'pending') {
            this.isModalClosable = false;
        } else if ( emittedData.status === 'success' ) {
            this.isDeletePolicyModalVisible = false;
            this.isModalClosable = true;
            this.getResourcePoolDetails(this.entity.entity_id, this.entity.vcenter_instanceId);
        } else {
            this.isModalClosable = true;
        }
    };

    onRestorePointsClick = (deletedVm) => {
        this.restorePointModalHeader = this.translate.instant('vcDpsModule.restorePoints.popupHeader') + deletedVm.name;
        this.restorePointsModalMode = DataProtectionVariables.RESTORE_MODES['DELETED_VM'];
        deletedVm['vcHost'] = this.vcHost;
        this.selectedDeletedVm = deletedVm;
        this.isRestorePointsModalVisible = true;
    };

    onRestorePointsModalClose = (emittedData) => {
        this.isRestorePointsModalVisible = false;
    };

    onConfigureEmailClick = (event) => {
        this.isConfigureEmailModalVisible = true;
    }

    onConfigureEmailClose = (emittedData) => {
        if ( !emittedData ) {
            this.isConfigureEmailModalVisible = false;
            this.isModalClosable = true;
        } else if ( emittedData.status === 'pending' ) {
            this.isModalClosable = false;
        } else if ( emittedData.status === 'success' ) {
            this.isConfigureEmailModalVisible = false;
            this.isModalClosable = true;
        } else {
            this.isModalClosable = true;
        }
    }


    ngOnInit() {
        this.refreshSubscription = this.rsService.getRefreshParam()
        .subscribe (
        item => {
          this.handleEmittedValues(item);
        });

        this.rsService.setParam({
            'loadedComponent': this.currentClassName,
            'detailPageIDName': '',
            'shouldReloadInventoryTree': true
        });
    }

    handleEmittedValues(item) {
        if (item.loadedComponent === this.currentClassName) {
            if (this.currentChanges) {
                this.getData(this.currentChanges);
            }
        }
    }

    ngOnChanges(changes) {
        this.currentChanges = changes;
        this.getData(changes);
    }

    getData(changes) {
        if (changes.entity && changes.entity.currentValue && changes.entity.currentValue.entity_id && changes.entity.currentValue.vcenter_instanceId) {
            this.getRPCompleted = false;
            this.getDelVMCompleted = false;
            this.getResourcePoolDetails(changes.entity.currentValue.entity_id, changes.entity.currentValue.vcenter_instanceId);
			this.getDeletedVms(changes.entity.currentValue.vcenter_instanceId, changes.entity.currentValue.entity_id);
            this.resourcePoolName = changes.entity.currentValue.name;
            this.vcHost = changes.entity.currentValue.vcHost;
        }
    }

    refresh() {
        if ( this.entity && this.entity.entity_id && this.entity.vcenter_instanceId ) {
            this.getResourcePoolDetails(this.entity.entity_id, this.entity.vcenter_instanceId);
            this.getDeletedVms(this.entity.vcenter_instanceId, this.entity.vcenter_instanceId);
        }
    }

    hideLoader() {
        if (this.getDelVMCompleted && this.getRPCompleted) {
            this.loaded = true;
        }
    }

    getDeletedVms(vcenterId: string, resourcePoolId: string) {
        this.resourcePoolService.getDeletedVmDetails(vcenterId, resourcePoolId)
            .subscribe(
                data => {
                    this.deletedVms = data;
                    this.deletedVmCount = this.deletedVms.length;
                    this.getDelVMCompleted = true;
                    this.hideLoader();
                },
                error => {
                    this.alert.danger(['Failed to retrieve deleted VMs', error],
                        'deleted-vm-grid');
                    this.getDelVMCompleted = true;
                    this.hideLoader();
                });
    }

    setResourcePoolDetails(details) {
        this.resourcePool = details;
        if ( this.resourcePool && this.resourcePool.schedule ) {
            this.policyData['schedule'] = JSON.parse(JSON.stringify(this.resourcePool.schedule));
            this.policyData['retention'] = JSON.parse(JSON.stringify(this.resourcePool.retention));
            this.isPolicySet = true;
        } else {
            this.isPolicySet = false;
        }
        this.policy = policyRender('', '', this.resourcePool);
        this.storageConsumed =storageRender('', '', this.resourcePool);
    }

    getResourcePoolDetails(id, vcId) {
        this.resourcePoolService.getResourcePoolDetails(id, vcId).subscribe(
            results => this.setResourcePoolDetails(results),
            error => {
                this.logError(error, 'get resource pool details');
                this.getRPCompleted = true;
                this.hideLoader();
            },
            () => {
                this.logOperationCompleted('get resource pool details');
                this.getRPCompleted = true;
                this.hideLoader();
            }
        );
    }

    logError(error, origin: String = '') {
        console.error('Error: ', error, (origin !== '') ? ' Error from ' + origin : '');
    }

    logOperationCompleted(msg: string) {
        console.log('Operation Completed: ', msg);
    }

  ngOnDestroy() {
    this.rsService.resetParam();
    if (this.refreshSubscription) {
        this.refreshSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/manage/resource-pool/resource-pool-details-vc.component.ts